import React from 'react'

import Base from '../_Base'

const BrazilL = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_l)">
      <rect width="24" height="24" rx="2" fill="#00A651" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.387 6.917c.932-.014 1.449 0 2.38-.007.028 2.735.008 5.04.008 7.776 1.503.006 3.326-.014 4.83.006.02.653.007 1.742.007 2.395-2.443.007-4.783 0-7.225 0 0-3.381-.007-6.776 0-10.17Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_l">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilL
